import { Building2, Briefcase } from 'lucide-react';
import { Button } from '../ui/button';

export const StepModePicker = ({ step, showAccessRequest, setMode, setStep, setProjectQuery, quoteForm, onClose }) => {
  if (step !== 0 || showAccessRequest) return null;
  return (
    <>
      <div className="text-center pt-2">
        <h3 className="text-lg font-extrabold text-gray-900 tracking-tight">What are you adding?</h3>
        <p className="text-xs text-gray-500 mt-1">Pick one — this changes the workflow.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
        <button
          type="button"
          onClick={() => {
            setMode('project');
            setStep(1);
            setProjectQuery(quoteForm?.notes?.replace(/^project:\s*/i, '').trim() || '');
          }}
          className="group text-left p-5 rounded-2xl border-2 border-gray-200 hover:border-blue-500 hover:shadow-md bg-white transition-all"
          data-testid="crm-mode-project"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <Briefcase className="w-5 h-5 text-blue-600" />
            </div>
            <div className="font-extrabold text-gray-900">Project quote</div>
          </div>
          <p className="text-xs text-gray-500 leading-relaxed">
            Linked to a Zoho project. Pick the project, then the main/sub contractor and package — the contractor becomes the account on the quote.
          </p>
        </button>

        <button
          type="button"
          onClick={() => { setMode('quote'); setStep(1); }}
          className="group text-left p-5 rounded-2xl border-2 border-gray-200 hover:border-blue-500 hover:shadow-md bg-white transition-all"
          data-testid="crm-mode-quote"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center">
              <Building2 className="w-5 h-5 text-emerald-600" />
            </div>
            <div className="font-extrabold text-gray-900">Standalone quote</div>
          </div>
          <p className="text-xs text-gray-500 leading-relaxed">
            Just a customer quote, no project. Pick the customer account from the parsed quote name, then fill in the quote details.
          </p>
        </button>
      </div>
      <div className="flex justify-end pt-2">
        <Button variant="outline" onClick={onClose}>Cancel</Button>
      </div>
    </>
  );
};
